<template>
  <a @click="handleClick"
          class="link">
    <slot></slot>
  </a>
</template>

<script>
  export default {
    methods: {
        handleClick(e) {
            this.$emit('click', e);
        }
    }
  }
</script>

<style scoped lang="less">
.link {
  position: relative;
  padding: 5px 10px 5px 10px;
  color: var(--color-main);
  text-decoration: none;
  z-index: 1;
  cursor: pointer;
  transition: color 0.2s ease;

  &::after {
    content: '';
    position: absolute;
    bottom: 4px;
    left: 0;
    width: 100%;
    height: 100%;

    background: #09777211;

    transform: scaleY(0.2);
    transform-origin: bottom;
    transition: all 0.2s ease-in-out;
    z-index: -1;
    content: '';
  }

  &:hover {
    color: var(--color-hover);

    &::after {
      bottom: 0;
      transform: scaleY(1);
    }
  }

}
.colored-bg {
  color: #fff;
  border-bottom-color: #FFF7;

  &::after {
    background: #fff1;
  }

  &:hover {
    border-bottom-color: #fff;
  }
}

.link--icon-only {
  &::after {
    display: none;
  }
}
</style>
